import React, {useEffect, useRef, useState} from 'react';
import cx from 'classnames';
import {useLocation} from 'react-router-dom';

import styles from './styles.module.scss';
import {shouldScrollToTop} from './scrollToTop';
import ProjectsIIRSA from "~screens/Dashboard/screens/ProjectsIIRSA";


import Navbar from '~components/Navbar';
import Drawer from "~components/Drawer";
import Login from "~screens/Login";
import usePageTracking from '../../../utils/usePageTracking';

const AppRoutes = () => {
    usePageTracking();

    const location = useLocation();
    const {pathname} = location;
    const panelRef = useRef<HTMLDivElement>(null);
    const previousPathname = useRef(pathname);

    // Only the panel scrolls (on phones, the window), so it takes over react-admin's scroll to top.
    useEffect(() => {
        if (shouldScrollToTop(previousPathname.current, location)) {
            panelRef.current?.scrollTo(0, 0);
            window.scrollTo(0, 0);
        }
        previousPathname.current = location.pathname;
    }, [location]);

    const [state, setState] = useState({
        searchExpanded: false,
        drawerOpen: false
    });

    const openDrawer = () => {
        setState({...state, drawerOpen: true});
    }

    const closeDrawer = () => {
        setState({...state, drawerOpen: false});
    }

    const {drawerOpen} = state;

    // The open menu overlays the page, so the content always leaves room for the closed menu only.
    const panelClassName = cx(styles.panel, styles.containedDrawerClosed);

    if (pathname === '/login') {
        return (
            <div className={styles.shell}>
                <Navbar/>
                <div className={styles.panel} ref={panelRef}>
                    <Login/>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.shell}>
            <Navbar/>
            <Drawer open={drawerOpen} closeDrawer={closeDrawer} openDrawer={openDrawer}/>
            <div className={panelClassName} ref={panelRef}>
                <ProjectsIIRSA/>
            </div>
        </div>
    );
}

export default AppRoutes;
